import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function CheckboxSection({ inputData, setInputDataToSend }) {
  const classes = useStyles();

  const handleCheck = () => {
    setInputDataToSend('doublePost', !inputData?.doublePost);
  };

  useEffect(() => {
    setInputDataToSend('doublePost', false);
    return () => setInputDataToSend('doublePost', undefined);
  }, []);

  return (
    <FormControl className={classes.checkbox}>
      <FormControlLabel
        value="end"
        control={<Checkbox onChange={handleCheck} />}
        label="Tick the box for Double Corner Post System"
        labelPlacement="end"
      />
    </FormControl>
  );
}

CheckboxSection.propTypes = {
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
};
